module.exports = __webpack_public_path__ + "assets/images/artist5.3727b56e.jpg";